export { default as interactivityPNG } from '~/assets/images/intro-card-interactivity.png'
export { default as interactivityWEBP } from '~/assets/images/intro-card-interactivity.webp'
export { default as discoveryPNG } from '~/assets/images/intro-card-discovery.png'
export { default as discoveryWEBP } from '~/assets/images/intro-card-discovery.webp'
export { default as knowledgePNG } from '~/assets/images/intro-card-knowledge.png'
export { default as knowledgeWEBP } from '~/assets/images/intro-card-knowledge.webp'
export { default as earth } from '~/assets/images/intro-card-earth.png'
export { default as uncoverPNG } from '~/assets/images/intro-card-uncover.png'
export { default as uncoverWEBP } from '~/assets/images/intro-card-uncover.webp'
export { default as growingPNG } from '~/assets/images/intro-card-keep-growing.png'
export { default as growingWEBP } from '~/assets/images/intro-card-keep-growing.webp'
export { default as goalPNG } from '~/assets/images/intro-card-goal.png'
export { default as goalWEBP } from '~/assets/images/intro-card-goal.webp'
export { default as neverStopLearningMalePNG } from '~/assets/images/intro-card-never-stop-learning-male.png'
export { default as neverStopLearningMaleWEBP } from '~/assets/images/intro-card-never-stop-learning-male.webp'
export { default as neverStopLearningFemalePNG } from '~/assets/images/intro-card-never-stop-learning-female.png'
export { default as neverStopLearningFemaleWEBP } from '~/assets/images/intro-card-never-stop-learning-female.webp'

export const GOAL_QUESTION = 'Our goal is to help you achieve yours!'
export const INTERACTIVITY_QUESTION =
  'Interactive learning that actually clicks'
export const DISCOVERY_QUESTION = 'Discover biology made simple'
export const KNOWLEDGE_QUESTION = 'Excellent knowledge!'
export const KEEP_GROWING_QUESTION = 'Keep growing with guidance from experts'
export const GOOD_COMPANY_QUESTION = `You're in good company!`
export const UNCOVER_QUESTION = `Enjoyed that? There's so much more to uncover`
export const GRAPH_QUESTION = 'Your personal plan'
export const NEVER_STOP_LEARNING_QUESTION = 'Never stop learning'

export const EMAILS = [
  'novarix01@gmail.com',
  'xelmira@hotmail.com',
  'trivoxa03@yahoo.com',
  'marzelo@outlook.com',
  'quintaro05@aol.com',
  'velnity@icloud.com',
  'zorelia07@live.com',
  'krydon@msn.com',
  'lunvex09@me.com',
  'fardino@mac.com',
  'tempiro11@googlemail.com',
  'jaxoria@facebook.com',
  'nexlora13@verizon.net',
  'vorlix@rediffmail.com',
  'silvano15@zohomail.com',
  'dravino@zoho.com',
  'polaris17@mail.com',
  'merqato@google.com',
  'zantrix19@comcast.com',
  'helvoro@hotmail.co.uk',
  'orvella21@yahoo.co.uk',
  'cintaro@att.net',
  'brivox23@gmz.com',
  'torevia@gmail.com',
  'glenvix25@hotmail.com',
  'ravenor@yahoo.com',
  'dexlina27@outlook.com',
  'morlix@aol.com',
  'veltoro29@icloud.com',
  'zanella@live.com',
  'quorix31@msn.com',
  'limvaro@me.com',
  'norvex33@mac.com',
  'tarsina@googlemail.com',
  'xelvoro35@zohomail.com',
  'pravina@zoho.com',
  'monzelo37@mail.com',
  'kirvex@comcast.com',
  'solvani39@yahoo.co.uk',
  'trevoro@att.net',
] as const
